"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOtherPinComponents = exports.clonePinComponents = exports.initialPinComponentPosition = exports.canDeletePinComponent = exports.sortPinComponents = void 0;
const assertions_1 = require("../assertions");
const component_reference_processor_1 = require("../component-reference.processor");
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
function sortPinComponents(components) {
    return [...components].sort(order_1.orderableCompareFn);
}
exports.sortPinComponents = sortPinComponents;
function canDeletePinComponent(pin, component) {
    return !(0, assertions_1.isInteractiveQuestionPinTextPinComponent)(pin, component) && !(0, assertions_1.isAnswerAreaPinComponent)(component);
}
exports.canDeletePinComponent = canDeletePinComponent;
exports.initialPinComponentPosition = (0, geometry_1.newVector)(25, 25);
function clonePinComponents(pinComponents, targetPin) {
    const oldToNewPinComponentIds = {};
    const mappedPinComponents = pinComponents.map((component) => {
        const newComponentId = (0, random_id_1.randomId)();
        oldToNewPinComponentIds[component.id] = newComponentId;
        return {
            ...component,
            id: newComponentId,
        };
    });
    mappedPinComponents.forEach((component, index) => {
        (0, component_reference_processor_1.processPinComponentReferenceFields)(component, ({ componentId }) => {
            return handleNewLinkedPinComponent(componentId, getOtherPinComponents(index, pinComponents, targetPin), oldToNewPinComponentIds);
        });
    });
    return { pinComponents: mappedPinComponents, oldToNewPinComponentIds };
}
exports.clonePinComponents = clonePinComponents;
function getOtherPinComponents(ignoredIndex, pinComponents, pin) {
    return [...(pin?.pinComponents || []), ...pinComponents.filter((_, filterIndex) => filterIndex !== ignoredIndex)];
}
exports.getOtherPinComponents = getOtherPinComponents;
function handleNewLinkedPinComponent(originalLinkedPinComponent, otherPinComponents, clonedIdsMap) {
    if (!originalLinkedPinComponent)
        return undefined;
    if (clonedIdsMap[originalLinkedPinComponent]) {
        return clonedIdsMap[originalLinkedPinComponent];
    }
    if (otherPinComponents.map((pinComponent) => pinComponent.id).includes(originalLinkedPinComponent)) {
        return originalLinkedPinComponent;
    }
    return undefined;
}
//# sourceMappingURL=pin-component.js.map